var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckNew = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.650024,
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1726_8703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 41,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.775,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1726_8703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1657 40.3594L42.7321 28.793L40.4352 26.4961L31.1657 35.7656L26.4899 31.0898L24.193 33.3867L31.1657 40.3594ZM33.4625 49.2188C31.193 49.2188 29.0602 48.7881 27.0641 47.9268C25.068 47.0654 23.3317 45.8965 21.8551 44.4199C20.3785 42.9434 19.2096 41.207 18.3483 39.2109C17.4869 37.2148 17.0563 35.082 17.0563 32.8125C17.0563 30.543 17.4869 28.4102 18.3483 26.4141C19.2096 24.418 20.3785 22.6816 21.8551 21.2051C23.3317 19.7285 25.068 18.5596 27.0641 17.6982C29.0602 16.8369 31.193 16.4062 33.4625 16.4062C35.7321 16.4062 37.8649 16.8369 39.861 17.6982C41.8571 18.5596 43.5934 19.7285 45.0699 21.2051C46.5465 22.6816 47.7155 24.418 48.5768 26.4141C49.4381 28.4102 49.8688 30.543 49.8688 32.8125C49.8688 35.082 49.4381 37.2148 48.5768 39.2109C47.7155 41.207 46.5465 42.9434 45.0699 44.4199C43.5934 45.8965 41.8571 47.0654 39.861 47.9268C37.8649 48.7881 35.7321 49.2188 33.4625 49.2188ZM33.4625 45.9375C37.1266 45.9375 40.2301 44.666 42.7731 42.123C45.316 39.5801 46.5875 36.4766 46.5875 32.8125C46.5875 29.1484 45.316 26.0449 42.7731 23.502C40.2301 20.959 37.1266 19.6875 33.4625 19.6875C29.7985 19.6875 26.6949 20.959 24.152 23.502C21.609 26.0449 20.3375 29.1484 20.3375 32.8125C20.3375 36.4766 21.609 39.5801 24.152 42.123C26.6949 44.666 29.7985 45.9375 33.4625 45.9375Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-new.ef96a9c4.svg";
export { ForwardRef as ReactComponent };